const mutations = {
  getInternalUsers: (state, internal_user) => {
    state.internal_user = internal_user;
  },
  getInternalUser: (state, internal_user_id) => {
    state.internal_user_id = internal_user_id;
  },
  getInternalUserHeader: (state, internal_user_header) => {
    state.internal_user_header = internal_user_header;
  },
  getRole: (state, role) => {
    state.role = role;
  },
  postInternalUser: (state, new_internal_user) => {
    state.internal_user.push(new_internal_user);
  },
  putInternalUser: (state, payload) => {
    state.internal_user = state.internal_user.map((internal_user) => {
      if (internal_user.id === payload.id) {
        return Object.assign({}, internal_user, payload.formData);
      }
      return internal_user;
    });
  },
  delInternalUser(state, id) {
    const index = state.internal_user.findIndex(internal_user => internal_user.id == id);
    state.internal_user.splice(index, 1);
  },
};

export default mutations;
